package com.macrofocus.eflux.network.crossborder

import com.macrofocus.common.units.Megawatt
import com.macrofocus.common.units.PhaseDegree
import com.macrofocus.common.units.Power
import com.macrofocus.common.units.Quantity
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Zone
import org.molap.network.Link

data class CrossborderBranches(override val from : Zone?, override val to : Zone?, val branches: List<Branch>) : Link<Zone?, Zone?> {
    val export: Quantity<Power>? = branches.fold(null as Quantity<Power>?) { acc, branch ->
        val phaseAngle = branch.dva

        // Inverted in graphical network?
        var outflow = from == branch.zone_k && to == branch.zone_m

        if (phaseAngle < 0.0.PhaseDegree) {
            outflow = !outflow
        }

        if (outflow) {
            if (acc == null)
                branch.p
            else
                acc + branch.p
        } else {
            acc
        }
    }

    val import: Quantity<Power>? = branches.fold(null as Quantity<Power>?) { acc, branch ->
        val phaseAngle = branch.dva

        // Inverted in graphical network?
        var outflow = from == branch.zone_k && to == branch.zone_m

        if (phaseAngle < 0.0.PhaseDegree) {
            outflow = !outflow
        }

        if (!outflow) {
            if (acc == null)
                branch.p
            else
                acc + branch.p
        } else {
            acc
        }
    }

    var netTradeBalance: Quantity<Power>? =
        if (import != null)
            if (export != null)
                export - import
            else
                0.0.Megawatt - import
        else
            export

//    var netTradeBalance2: Quantity<Power>? = branches.fold(null as Quantity<Power>?) { acc, branch ->
//        val inverted = branch.zone_k != from
//        val p = if (inverted)
//            branch.dp * -1
//        else
//            branch.dp
//        if (acc == null)
//            p
//        else
//            acc + p
//    }
//
//    init {
//        if(netTradeBalance != netTradeBalance2) {
//            println("Something is wrong $netTradeBalance2 != $netTradeBalance ($export - $import)")
//        }
//    }
}
